import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from '../CommonController/common-api-service';
import { MatIcon } from '@angular/material/icon';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { DealerManagementApiService } from '../CommonController/dealerManagement-api-service';
import { NgxPaginationModule } from 'ngx-pagination';
import { HttpErrorResponse } from '@angular/common/http';
import { JsonPipe } from '@angular/common';
@Component({
  selector: 'app-dealers-ota-page',
  templateUrl: './dealers-ota-page.component.html',
  styleUrls: ['./dealers-ota-page.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    NgxPaginationModule,
    JsonPipe,
  ],
})
export class DealersOtaPageComponent implements OnInit {
  // Pagination settings
  pageSize = 10; // Number of items per currentPage
  currentPage = 1; // Current currentPage
  totalItems = 0; // Total number of items (for pagination purposes)
  searchText = ''; // Search text
  dealersOtaList = [];

  userPermission = [];
  DealersOTAView = true;
  loggedId = '';

  constructor(
    public dealerManagementApiService: DealerManagementApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    // Resetting the page
    this.pageSize = 10; // Number of items per currentPage
    this.currentPage = 1; // Current currentPage
    this.totalItems = 0; // Total number of items (for pagination purposes)
    this.dealersOtaList = [];
    this.fetchDealersOtaList();
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Dealers OTA' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Dealers OTA' && element.view === true) {
        this.DealersOTAView = true;
      }
    });
  }

  fetchDealersOtaList() {
    this.spinner.show();
    this.dealerManagementApiService
      .getAllDealersOtaList(this.currentPage, this.pageSize, this.searchText)
      .subscribe({
        next: (res) => {
          this.dealersOtaList = res.data;
          this.totalItems = res.totalItems;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          if (error.status === 404) {
            this.dealersOtaList = []; // Clear the list
            this.totalItems = 0; // Reset the total count
            // this.currentPage = 0;
            this.currentPage = 1;
            // this.currentPage = this.currentPage + 1;
            this.commonApiService.openSnackbar(error.error.message);
          } else {
            this.commonApiService.openSnackbar(
              'An error occurred while fetching data.'
            );
          }
        },
      });
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchDealersOtaList();
  }

  onSearchInputChange(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.fetchDealersOtaList();
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchDealersOtaList();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
